module.exports = __webpack_public_path__ + "img/bz.fd9b8d37.svg";